import React from 'react'
import config from 'config'

const initialState = config.USER_PREFERENCES_DEFAULT

const UserPreferencesContext = React.createContext(initialState)

export default UserPreferencesContext
